export default "__VITE_ASSET__d76117bb__"